import { styled } from '@mui/material';

// eslint-disable-next-line import/prefer-default-export
export const UrlViewerContent = styled('div')(({ theme }) => ({
  '& .heading': {
    color: theme.palette.primary.light2,
    fontFamily: theme.typography.monospace.fontFamily,
    fontSize: '.875rem',
    borderBottom: `1px solid ${theme.palette.grey[600]}`,
    paddingBottom: theme.spacing(1),
    marginBottom: theme.spacing(3),

    '& span': {
      position: 'relative',
      padding: theme.spacing(0, 2, 1),

      '&:after': {
        position: 'absolute',
        content: '""',
        width: '100%',
        height: '2px',
        top: '100%',
        left: '0',
        backgroundColor: theme.palette.primary.light2,
      },
    },
  },

  '& .output': {
    fontFamily: theme.typography.monospace.fontFamily,
    fontSize: theme.typography.body2.fontSize,
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(3),
    borderBottom: `1px solid ${theme.palette.grey[600]}`,

    '& p': {
      lineHeight: '1.25rem',
      margin: '0',
      overflowWrap: 'anywhere',

      '&.missing-param': {
        color: theme.palette.error.main,
      },
    },

  },
}));

